import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { handleEventKeySubmit } from "../../common/Utils/commonFunction";
import { showToast } from "../../common/Utils/ToastMessage";
import { useChangePasswordMutation } from "../../request/Authentication";
import { CreateApi } from "../../request/CreateApi";
import {
  selectCompanyAction,
  setFcmTokenAction,
  setNotificationBody,
  setNotificationLogout,
  userDataAction,
  userTypeAction,
} from "../../store/Reducer";
import Translate from "../../translation/utils/translateFunction";
import { FormikTextField } from "../FormikForm/component/FormikTextField";
import Loader from "../staff/Owner/LoadingComp";
import { ChangePassInitialValues } from "./constants";
import { ChangePasswordSchema } from "./utils";
import { useNavigate } from "react-router-dom";

export const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [
    changePassword,
    {
      data: changePasswordData,
      isSuccess: successChangePassword,
      isError: isErrorChangePassword,
      error: errorChangePassword,
      isLoading,
    },
  ] = useChangePasswordMutation();

  const onSubmit = async (changePasswordValues) => {
    let requestObject = {
      oldPassword: changePasswordValues?.oldPass,
      newPassword: changePasswordValues?.newPass,
      confirmPassword: changePasswordValues?.confirmPass,
    };
    changePassword(requestObject);
  };

  useEffect(() => {
    if (successChangePassword) {
      if (changePasswordData?.success) {
        showToast({ message: changePasswordData.message, type: "success" });
        setTimeout(() => {
          localStorage.removeItem("userData");
          dispatch(userDataAction(undefined));
          dispatch(userTypeAction(undefined));
          dispatch(setNotificationLogout(false));
          dispatch(setNotificationBody(undefined));
          dispatch(selectCompanyAction([]));
          dispatch(setFcmTokenAction(""));
          dispatch(CreateApi.util.resetApiState());
          dispatch(
            CreateApi.endpoints.getCompanyList.initiate(undefined, {
              forceRefetch: true,
            })
          );
          navigate("/login");
        }, 3000);
      } else {
        showToast({ message: changePasswordData.message, type: "error" });
      }
    }
    if (isErrorChangePassword) {
      console.log("isErrorChangePassword", errorChangePassword);
      showToast({ message: errorChangePassword?.data?.message, type: "error" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    successChangePassword,
    changePasswordData,
    isErrorChangePassword,
    errorChangePassword,
  ]);

  return (
    <>
      <Formik
        initialValues={ChangePassInitialValues}
        validateOnMount
        validationSchema={ChangePasswordSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => {
          return (
            <div className="row container_spacing">
              <div className="card card_spacing">
                <div className="page-title formTitle p-3 row align-items-center mb-3">
                  {Translate("changePassword:changePassword")}
                </div>
                <div
                  className="card-body"
                  id="changePassword"
                  onKeyDown={(e) => handleEventKeySubmit(e, handleSubmit)}
                >
                  <div className="row">
                    <div className="form-group col-md-4 col-sm 12">
                      <FormikTextField
                        name="oldPass"
                        label={Translate("changePassword:oldPass")}
                        placeholder={Translate("changePassword:oldPass")}
                        autoComplete={"off"}
                        type={showOldPassword ? "text" : "password"}
                        RenderRightContainer={
                          showOldPassword ? (
                            <i
                              className="fe fe-eye cursor-pointer passwordIcon-alignement"
                              onClick={() => setShowOldPassword(false)}
                            />
                          ) : (
                            <i
                              className="fe fe-eye-off cursor-pointer passwordIcon-alignement"
                              onClick={() => setShowOldPassword(true)}
                            />
                          )
                        }
                        showPassword={showOldPassword}
                        autoFocus
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-4 col-sm 12">
                      <FormikTextField
                        name="newPass"
                        label={Translate("changePassword:newPass")}
                        placeholder={Translate("changePassword:newPass")}
                        autoComplete={"off"}
                        type={showNewPassword ? "text" : "password"}
                        RenderRightContainer={
                          showNewPassword ? (
                            <i
                              className="fe fe-eye cursor-pointer passwordIcon-alignement"
                              onClick={() => setShowNewPassword(false)}
                            />
                          ) : (
                            <i
                              className="fe fe-eye-off cursor-pointer passwordIcon-alignement"
                              onClick={() => setShowNewPassword(true)}
                            />
                          )
                        }
                        showPassword={showNewPassword}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-4 col-sm 12">
                      <FormikTextField
                        name="confirmPass"
                        label={Translate("changePassword:confirmPass")}
                        placeholder={Translate("changePassword:confirmPass")}
                        autoComplete={"off"}
                        type={showConfirmPassword ? "text" : "password"}
                        RenderRightContainer={
                          showConfirmPassword ? (
                            <i
                              className="fe fe-eye cursor-pointer passwordIcon-alignement"
                              onClick={() => setShowConfirmPassword(false)}
                            />
                          ) : (
                            <i
                              className="fe fe-eye-off cursor-pointer passwordIcon-alignement"
                              onClick={() => setShowConfirmPassword(true)}
                            />
                          )
                        }
                        showPassword={showConfirmPassword}
                      />
                    </div>
                  </div>

                  <div className="card-footer text-right line_spacing">
                    <button
                      type="submit"
                      className="btn btn-primary saveButton"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      {Translate("changePassword:save")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
      <Loader loading={isLoading} />
    </>
  );
};

export default ChangePassword;
